import { motion } from "framer-motion";
import { Home, HardHat, Building2, Leaf, ArrowUpRight } from "lucide-react";

const SERVICES = [
  {
    icon: Home,
    title: "Lakás- és Pinceürítés",
    desc: "Teljes ingatlan kiürítés, bútorok, hagyaték elszállítása. Tisztán adjuk át a területet.",
    span: "md:col-span-7",
    testid: "service-flat",
  },
  {
    icon: HardHat,
    title: "Építési Törmelék Elszállítás",
    desc: "Zsákos sitthordás, bontási hulladék kisteherautóval, akár aznapi kiszállással.",
    span: "md:col-span-5",
    testid: "service-debris",
  },
  {
    icon: Building2,
    title: "Iroda & Raktár Lomtalanítás",
    desc: "Céges bútorok, selejtezett gépek és eszközök elszállítása számlaképesen.",
    span: "md:col-span-5",
    testid: "service-office",
  },
  {
    icon: Leaf,
    title: "Kert & Zöldhulladék Elszállítás",
    desc: "Gallyak, levágott fű, kerti hulladék környezetbarát kezeléssel.",
    span: "md:col-span-7",
    testid: "service-garden",
  },
];

export default function Services() {
  return (
    <section id="szolgaltatasok" data-testid="services-section" className="py-24 lg:py-32">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <motion.div
          initial={{ opacity: 0, y: 32 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 0.7 }}
          className="mb-14"
        >
          <p className="text-xs font-bold uppercase tracking-[0.25em] text-[#16A34A] mb-4">01 / Szolgáltatásaink</p>
          <h2 className="font-display font-black tracking-tighter text-[#1E293B] text-4xl sm:text-5xl">
            Amitől megszabadítunk.
          </h2>
          <p className="mt-4 text-base md:text-lg text-[#64748B] max-w-2xl">
            Egy telefonhívás vagy egy fotó elég – minden mást mi intézünk, a pakolástól a szállításig.
          </p>
        </motion.div>

        <div className="grid md:grid-cols-12 gap-6 lg:gap-8">
          {SERVICES.map(({ icon: Icon, title, desc, span, testid }, i) => (
            <motion.div
              key={testid}
              data-testid={testid}
              initial={{ opacity: 0, y: 40 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-60px" }}
              transition={{ duration: 0.6, delay: i * 0.1 }}
              className={`group bg-white rounded-3xl border border-[#E2E8F0] p-8 lg:p-10 shadow-[0_8px_30px_rgb(0,0,0,0.04)] hover:shadow-xl hover:-translate-y-2 transition-[box-shadow,transform] duration-300 relative overflow-hidden ${span}`}
            >
              <span className="absolute top-6 right-8 font-display font-black text-6xl text-[#F1F5F9] group-hover:text-green-100 transition-colors select-none">
                0{i + 1}
              </span>
              <div className="w-14 h-14 rounded-2xl bg-green-50 flex items-center justify-center mb-6 group-hover:bg-[#16A34A] transition-colors">
                <Icon className="w-7 h-7 text-[#16A34A] group-hover:text-white transition-colors" />
              </div>
              <h3 className="font-display font-extrabold text-[#1E293B] text-xl lg:text-2xl tracking-tight mb-3 flex items-center gap-2">
                {title}
                <ArrowUpRight className="w-5 h-5 text-[#16A34A] opacity-0 group-hover:opacity-100 transition-opacity" />
              </h3>
              <p className="text-sm md:text-base text-[#64748B] leading-relaxed max-w-md">{desc}</p>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
